import React from 'react';
import './BatchBadge.css';

const BatchBadge = ({ 
  batches = [],
  isUnassigned = false
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (isUnassigned) {
    return (
      <div className="batch-badge batch-badge--unassigned" title="This case has never been assigned to any batch">
        <span className="badge-icon">✨</span>
        <span className="badge-text">UNASSIGNED</span>
      </div>
    );
  }

  // Filter out empty batches
  const validBatches = batches.filter(b => b && b.batch_name);
  
  if (validBatches.length === 0) {
    return (
      <div className="batch-badge batch-badge--unassigned" title="This case has never been assigned to any batch">
        <span className="badge-icon">✨</span>
        <span className="badge-text">UNASSIGNED</span>
      </div>
    );
  }

  return (
    <div className="batch-badge-container">
      {validBatches.map((batch, idx) => (
        <div 
          key={idx}
          className="batch-badge batch-badge--assigned"
          title={`Assigned on ${formatDate(batch.assigned_at)} at ${formatTime(batch.assigned_at)}`}
        >
          <span className="badge-icon">📋</span>
          <span className="badge-text">{batch.batch_name}</span>
          {batch.assigned_at && (
            <span className="badge-date" title={batch.assigned_at}>
              {formatDate(batch.assigned_at)}
            </span>
          )}
        </div>
      ))}
      
      {validBatches.length > 2 && (
        <div className="batch-badge--multi-count">
          <span className="multi-info">
            {validBatches.length} batches assigned
          </span>
        </div>
      )}
    </div>
  );
};

export default BatchBadge;
